/**
 * @generated SignedSource<<e035f4b163bfb2e3dcbec7be244a1e21>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaglineLink_tagLineLink$data = {
  readonly tagline: string;
  readonly text: string;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "TaglineLink_tagLineLink";
};
export type TaglineLink_tagLineLink$key = {
  readonly " $data"?: TaglineLink_tagLineLink$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaglineLink_tagLineLink">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaglineLink_tagLineLink",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tagline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "type": "TaglineLink",
  "abstractKey": null
};

(node as any).hash = "2b72b714b2377661cacc82a6a65e1bab";

export default node;
